// Export all components
export { default as Header } from './Header';
export { default as Hero } from './Hero';
export { default as Features } from './Features';
export { default as WhyUs } from './WhyUs';
export { default as About } from './About';
export { default as Contact } from './Contact';
export { default as Footer } from './Footer'; 